import type { Product, ProductTextColumn } from '@/types'

const priceFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0
})

export const formatPrice = (value: number): string => priceFormatter.format(value)

// Inline-editing key for a product text value: `products:<row id>:<column>`.
// Returns undefined for the fallback collection (no real row), so React omits the attribute.
export const productCmsKey = (product: Pick<Product, 'id'>, column: ProductTextColumn): string | undefined =>
    product.id ? `products:${product.id}:${column}` : undefined

export const firstName = (fullName: string): string => fullName.trim().split(' ')[0] ?? ''
